import { render, staticRenderFns } from "./organizationMessageBranch.vue?vue&type=template&id=d8eb3a86"
import script from "./organizationMessageBranch.vue?vue&type=script&lang=js"
export * from "./organizationMessageBranch.vue?vue&type=script&lang=js"
import style0 from "./organizationMessageBranch.vue?vue&type=style&index=0&id=d8eb3a86&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports